module.exports = __webpack_public_path__ + "static/media/ai.8867e863.jpeg";